import { useEffect, useState } from 'react';
import { getMonthlySeriesByTeam } from '../services';
import { IMonthlySeriesByTeamItem, HookState } from '../types';
import { resolveErrorMessage } from './hookUtils';

export function useMonthlySeriesByTeam(options?: { team?: string }): HookState<IMonthlySeriesByTeamItem[]> {
	const [state, setState] = useState<HookState<IMonthlySeriesByTeamItem[]>>({
		data: null,
		loading: true,
		error: null,
		cachedAt: null,
	});

	const team = options?.team;

	useEffect(() => {
		if (!team) {
			setState({ data: null, loading: false, error: null, cachedAt: null });
			return;
		}

		let cancelled = false;
		const controller = new AbortController();
		setState((prev) => ({ ...prev, loading: true, error: null }));

		getMonthlySeriesByTeam({ team })
			.then(({ data, cachedAt }) => {
				if (!cancelled) setState({ data, loading: false, error: null, cachedAt });
			})
			.catch((err) => {
				if (!cancelled && !controller.signal.aborted)
					setState({ data: null, loading: false, error: resolveErrorMessage(err), cachedAt: null });
			});

		return () => {
			cancelled = true;
			controller.abort();
		};
	}, [team]);

	return state;
}
